import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import _ from 'lodash';
import {
    PATIENT_STATUS_PENDING,
    PATIENT_STATUS_UNENROLLED,
    PATIENT_STATUS_REJECTED,
    PATIENT_STATUS_OPTED_OUT,
    PATIENT_STATUS_UNENROLL_PENDING,
    PATIENT_STATUS_RPM_UNVERIFIED,
    PATIENT_STATUS_RPM_INCORRECT_PHONE_NUMBER,
    PATIENT_STATUS_EXHAUSTED,
    PATIENT_RE_ENGAGE,
    PATIENT_STATUS_SUPPORT,
    PATIENT_STATUS_ACTIVE,
    PATIENT_STATUS_NEW,
    PATIENT_STATUS_UNVERIFIED,
    PATIENT_STATUS_DO_NOT_CALL,
    PATIENT_STATUS_REMOVE_FROM_QUEUE
} from '../../constants/other';

import {STATUSES} from '../../constants/other';
import { isAutoDial, isPatientChartOpenForActivity } from '../../utils';
import { RPM_ADDON_STATUS_ELIGIBLE } from '../../constants/other';

class StatusActionsColumn extends Component {
    constructor(props) {
        super(props);
        this.state = {
            chartOpenedBy: {},
        };
    }

    getChartOpenBy = () =>
        this.props.onGetChartOpenBy(this.props.patient.id)
            .then((chartOpenedBy) => {
                this.setState({ chartOpenedBy });
            })
            .catch(() => false);

    handleRequestChartClosure = () => {
        this.props.requestChartClosure( this.props.patient.id );
    };

    render() {
        const {
            patient,
            isUserAdmin,
            activeUser,
            allowRpmEnrollButton,
            rpmEnrollOnlyMode,
            onRpmEnroll,
        } = this.props;
        const isRpmEligible = patient.rpm_addon_status_id === RPM_ADDON_STATUS_ELIGIBLE;
        const isRPM = activeUser && activeUser.center && activeUser.center.rpm_flag;
        const { chartOpenedBy } = this.state;
        const chartIsOpen = isPatientChartOpenForActivity(
            patient,
            activeUser,
            this.props.userRoles
        );
        const reengagePatient = patient.status === PATIENT_RE_ENGAGE;
        let inPendingStatus = patient.status === PATIENT_STATUS_PENDING;
        
        let canChartOpen = patient.status === PATIENT_STATUS_NEW ||
           patient.status === PATIENT_STATUS_ACTIVE || 
            patient.status === PATIENT_STATUS_SUPPORT || 
            patient.status === PATIENT_STATUS_UNVERIFIED;

        let canShowMoveToUnverified = patient.status === PATIENT_STATUS_EXHAUSTED; 
        let canShowPHS = patient.status === PATIENT_STATUS_UNENROLL_PENDING || 
                patient.status === PATIENT_STATUS_UNENROLLED;

        
        const latest_checkout_ts = patient.latest_checkout_ts;
        const latest_checkin_ts = patient.latest_checkin_ts;
        const inAutoDial = isAutoDial(latest_checkout_ts,latest_checkin_ts);
       
        if(isRPM){
            inPendingStatus = false;
            canShowMoveToUnverified = false;
            let eligibleToOpen = false;
            canShowPHS = false;
            if(patient.status == PATIENT_STATUS_RPM_UNVERIFIED  || patient.status == PATIENT_STATUS_RPM_INCORRECT_PHONE_NUMBER){
                eligibleToOpen = true;
            }else{
                canShowPHS = true;
            }
        }
        return (
            <div style={{ textAlign: 'center' }}>
                <div style={{margin:15}}>
                    {STATUSES[patient.status] && <span style={{ fontWeight: 'normal' }}>{STATUSES[patient.status]}</span>}
                </div>
                {chartIsOpen && !_.isEmpty(chartOpenedBy) &&
                <div>
                    <span>{chartOpenedBy.name}</span>
                </div>
                }
                {chartIsOpen && _.isEmpty(chartOpenedBy) &&
                <div>
                    <Button
                        bsSize="small"
                        type="button"
                        onClick={this.getChartOpenBy}
                    >
                        Opened By?
                    </Button>
                </div>
                }
                {!chartIsOpen && inPendingStatus &&
                <div>
                    <Button
                        bsStyle="danger"
                        bsSize="small"
                        type="button"
                        style={{ marginRight: '10px' }}
                        onClick={() => this.props.onShowOptOut(patient)}
                    >
                        Opt Out
                    </Button>
                    <Button
                        bsStyle="success"
                        bsSize="small"
                        type="button"
                        onClick={() => this.props.onVerifyPatient(patient)}
                    >
                        Verify
                    </Button>
                </div>
                }
                {!chartIsOpen && !inPendingStatus && canChartOpen && !reengagePatient
                    && allowRpmEnrollButton && isRpmEligible && onRpmEnroll &&
                <Button
                    bsStyle="success"
                    bsSize="small"
                    type="button"
                    onClick={() => onRpmEnroll(patient)}
                >
                    RPM Enroll
                </Button>
                }
                {!chartIsOpen && !inPendingStatus && canChartOpen && !reengagePatient && !rpmEnrollOnlyMode
                    && !(allowRpmEnrollButton && isRpmEligible && onRpmEnroll) &&
                <Button
                    bsStyle="primary"
                    bsSize="small"
                    type="button"
                    onClick={() => this.props.onPatientSelect(patient)}
                >
                    Open Chart
                </Button>
                }
                {canShowMoveToUnverified && isUserAdmin &&
                <Button
                    bsStyle="primary"
                    bsSize="small"
                    type="button"
                    onClick={() => this.props.onShowUnDecline(patient)}
                >
                    Move to Unverified
                </Button>
                }
                {!chartIsOpen && canShowPHS &&
                <Button
                    bsStyle="primary"
                    bsSize="small"
                    type="button"
                    onClick={() => this.props.onShowPhs(patient)}
                >
                    Open PHS PDF
                </Button>
                }
                {
                    inAutoDial && <div style={{color:'#f52b04',margin:15}}>
                        <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        <span style={{fontSize:12,paddingLeft:2}}>In Autodial Queue</span>
                        </div>
                }
            </div>
        );
    }
}

export default StatusActionsColumn;
